// extracted by mini-css-extract-plugin
export default {"select":"SelectApp_select__aLx8K"};